import { Button, Typography } from "@joonapp/web-shared"

import OnboardingPageContentWrapper from "./onboardingPageContentWrapper/OnboardingPageContentWrapper"
import ParentSignupReasons from "./ParentSignupReasons"
import ParentTestimonialWithRibbon from "./ParentTestimonialWithRibbon"
import useOnboardContext from "../../hooks/useOnboardContext"
import { ANALYTIC_EVENTS, trackAnalyticEvent } from "../../util/analytics"
import ChevronBackButton from "../buttons/ChevronBackButton"

const OnboardCustomPlanSection = () => {
  const { previousStep, nextStep } = useOnboardContext()

  return (
    <OnboardingPageContentWrapper
      paddingTop="5dvh"
      style={{ position: "relative", overflowY: "auto" }}
      backgroundImageOnDesktop="url(/images/background/cloud-bg.png)"
    >
      <ChevronBackButton onClick={previousStep} />
      <div className="flex flex-col items-center gap-6">
        <Typography variant="h2Serif" textAlign="center">
          Your custom Joon Plan is ready!
        </Typography>
        <ParentSignupReasons />
        <ParentTestimonialWithRibbon />
      </div>
      <Button
        text="Get started now!"
        fullWidth
        onClick={() => {
          trackAnalyticEvent(ANALYTIC_EVENTS.GET_STARTED_FOR_FREE)
          nextStep()
        }}
        style={{
          position: "sticky",
          bottom: 0,
          zIndex: 10,
        }}
      />
    </OnboardingPageContentWrapper>
  )
}

export default OnboardCustomPlanSection
